<template>
  <div>
  <Card>
      <ExecShow ref="execShow"></ExecShow>
      <Row>
        <i-col span="24" :md="20">
          <Form ref="searchForm" inline :model="searchForm" :label-width="90" @submit.native.prevent>
            <FormItem label="名称/命名空间" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入名称/命名空间" style="min-width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getPodList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col span="24" :md="4" style="float:right">
          <Button @click="getPodList()" type="primary" :style="{marginBottom: '10px', float: 'right'}" icon="md-refresh">刷新</Button>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getPodList"></page>
        </div>
     </Row>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getPodList, deletePod, getPodLogs, getPodDetail } from '@/api/cloud'
import ExecShow from './exec-show'
export default {
  name: 'PodList',
  components: {
    Tables,
    ExecShow
  },
  data () {
    return {
      count: 1,
      size: 10,
      page: 1,
      change: false,
      ordering: null,
      jsonSource: {},
      columns: [
        { title: 'pod名称', key: 'name', align: 'center', minWidth: 200 },
        { title: '命名空间', key: 'namespace', align: 'center', minWidth: 200 },
        { title: '启动时间', key: 'start_time', align: 'center', minWidth: 150 },
        { title: '节点名', key: 'nodeName', align: 'center', minWidth: 100 },
        { title: 'IP地址', key: 'podIP', align: 'center', minWidth: 120 },
        {
          title: '状态',
          key: 'status',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            const row = params.row
            const color = row.status === 'Running' ? 'success' : 'error'
            const text = row.status === 'Running' ? '运行中' : '已断开'
            return h('Tag', {
              props: {
                type: 'dot',
                color: color
              }
            }, text)
          }
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 190,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small',
                    title: '详情'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.viewDetail(params)
                    }
                  }
                }, '详情'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small',
                    title: 'Logs'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.playLogs(params)
                    }
                  }
                }, '日志'),
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small',
                    title: 'Logs'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$refs.execShow.openModal(params)
                    }
                  }
                }, '执行'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?',
                    transfer: true
                  },
                  on: {
                    'on-ok': () => {
                      this.deletePod(params.row.name)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small',
                      title: 'Delete'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }, '删除')
                ])
              ])
            } else {}
          }
        }
      ],
      tableData: [],
      changeLoadingShow: false,
      searchForm: {
        name: null
      },
      listStyle: {
        width: '250px',
        height: '300px'
      }
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      this.getPodList()
    }
  },
  methods: {
    getPodList (value = 1) {
      this.page = value
      let params = {
        page: this.page,
        search: this.searchForm.name
      }
      getPodList(params).then(res => {
        this.tableData = res.data.results
        this.count = res.data.count
      })
    },
    searchReset () {
      this.searchForm.name = null
    },
    playLogs (params) {
      this.handleRender(params)
    },
    viewDetail (params) {
      this.handleRenderDetail(params)
    },
    handleRenderDetail (params) {
      let data = {
        name: params.row.name,
        namespace: params.row.namespace
      }
      getPodDetail(data).then(res => {
        let data = res.data
        this.$Modal.info({
          width: '750px',
          title: 'Pod详情',
          render: (h) => {
            return h('div', [
              h('span', {style: {color: '#515a6e'}}, 'pod:'),
              h('span', {style: {color: 'green'}}, params.row.name),
              h('span', {style: {color: '#515a6e', marginLeft: '5px'}}, '节点:'),
              h('span', {style: {color: 'green'}}, params.row.nodeName),
              h('span', {style: {color: '#515a6e', marginLeft: '5px'}}, 'IP地址:'),
              h('span', {style: {color: 'green'}}, params.row.podIP),
              h('Divider', {
              }),
              h('Input', {
                props: {
                  type: 'textarea',
                  value: data,
                  autofocus: true,
                  placeholder: '',
                  readonly: true,
                  autosize: { minRows: 10, maxRows: 20 }
                },
                style: {
                  width: '100%',
                  height: '100%'
                }
              })
            ])
          }
        })
      })
    },
    handleRender (params) {
      let data = {
        name: params.row.name,
        namespace: params.row.namespace
      }
      getPodLogs(data).then(res => {
        let data = res.data
        this.$Modal.info({
          width: '750px',
          title: '日志详情',
          render: (h) => {
            return h('div', [
              h('span', {style: {color: '#515a6e'}}, 'pod:'),
              h('span', {style: {color: 'green'}}, params.row.name),
              h('span', {style: {color: '#515a6e', marginLeft: '5px'}}, '节点:'),
              h('span', {style: {color: 'green'}}, params.row.nodeName),
              h('span', {style: {color: '#515a6e', marginLeft: '5px'}}, 'IP地址:'),
              h('span', {style: {color: 'green'}}, params.row.podIP),
              h('Divider', {
              }),
              h('Input', {
                props: {
                  type: 'textarea',
                  value: data,
                  autofocus: true,
                  placeholder: '',
                  disabled: true,
                  autosize: { minRows: 20, maxRows: 20 }
                },
                style: {
                  width: '100%',
                  height: '450px'
                }
              })
            ])
          }
        })
      })
    },
    deletePod (name) {
      deletePod(name).then(res => {
        if (res.status === 204) {
          this.$Message.success('删除Pod(' + name + ')成功')
          this.getPodList()
        } else {
          this.$Message.error('删除Pod(' + name + ')失败')
        }
      })
    }
  },
  mounted: function () {
    this.getPodList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
